import React from "react";
import PropTypes from "prop-types";
import Image from "theme/components/atoms/Image";
import ItemsSlider from "theme/components/organisms/ItemsSlider/ItemsSlider";
import { useSliderState } from "theme/components/organisms/Slider/Slider";

const GalleryNavigation = ({
  images,
  numberOfVisibleThumbnails,
  name,
  onImageClick,
  imageSizes,
}) => {
  const length = images.length;

  const sliderProps = useSliderState(
    Math.ceil(length / numberOfVisibleThumbnails)
  );

  return (
    <ItemsSlider
      sliderProps={sliderProps}
      itemsPerSlide={numberOfVisibleThumbnails}
      appearance="vertical"
    >
      {images.map((image) => (
        <button
          className="product-gallery__preview-button"
          key={image.id}
          onClick={() => onImageClick(image)}
        >
          <Image
            src={image.file}
            alt={image.alt || name}
            format="galleryPreview"
            appearance="full"
            sizes={imageSizes}
          />
        </button>
      ))}
    </ItemsSlider>
  );
};

GalleryNavigation.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      file: PropTypes.string.isRequired,
    })
  ).isRequired,
  name: PropTypes.string,
  onImageClick: PropTypes.func,
};

export default GalleryNavigation;
